var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGraphicSurpriseBubble(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 175,
    viewBox: "0 0 283 175",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_528_6781)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.427 48.1454C278.242 47.3419 278.027 46.5418 277.784 45.7521C274.75 35.9408 267.24 28.1815 258.905 22.4327C243.377 11.7248 224.701 6.88296 206.175 4.15167C167.903 -1.49713 128.997 1.06863 90.3737 2.93432C72.8757 3.77923 54.9634 4.56551 38.7282 11.3006C26.982 16.17 16.108 24.7226 9.96883 36.2443C3.01136 49.3007 3.12586 65.4677 3.86 79.938C4.60087 94.5118 7.20403 108.986 11.6223 122.859C14.6835 132.471 18.8593 142.158 26.3994 148.682C33.7003 155 43.3115 157.642 52.6566 159.711C108.118 171.981 166.512 170.091 221.104 154.259C232.456 150.965 244.021 146.862 252.672 138.647C260.488 131.226 265.26 121.063 268.948 110.824C273.874 97.1569 277.195 82.8831 278.818 68.4094C279.572 61.6639 279.943 54.715 278.427 48.1454Z",
    fill: "#263D4B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_528_6781",
    x: 0.345293,
    y: 0.703125,
    width: 282.31,
    height: 173.362,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.18095
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.59048
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_528_6781"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_528_6781",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraphicSurpriseBubble);
export default __webpack_public_path__ + "static/media/graphic-surprise-bubble.93778b739d2a4f03c2c2ce2d4228eb8a.svg";
export { ForwardRef as ReactComponent };